module.exports = __webpack_public_path__ + "img/black-car.74f961cf.png";